<template>
<div class="notifications-list">
  <single-notification
    v-for="notification in notifications"
    :notification="notification"
    :key="notification.id"
    class="mt-3"
    @close="$emit('close')"
  />
</div>
</template>

<script>
import SingleNotification from '@/components/notificationsNew/SingleNotification'
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'NotificationsList',
  extends: BaseComponent,
  components: { SingleNotification },
  props: {
    notifications: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.notifications-list {
  font-family: $font-lato;
}
</style>
